/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Dimension to group cost data by in the response. 
*/
export enum CostDataGroupBy {
  COST_GROUP_BY_SOURCE_ACCOUNT = 'SOURCE_ACCOUNT',
  COST_GROUP_BY_CLOUD_PROVIDER = 'CLOUD_PROVIDER',
  COST_GROUP_BY_RESOURCE_TYPE = 'RESOURCE_TYPE',
  COST_GROUP_BY_RESOURCE = 'RESOURCE',
  COST_GROUP_BY_RESOURCE_AND_VAULT = 'RESOURCE_AND_VAULT'
}
